





















import { SubscribedPaidMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import WillUnsubscribe from '@spa/components/pages/paid-membership/unsubscribe/atom/WillUnsubscribe.vue'
import BaseState from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/BaseState.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PlanSubscribingPeriod from './molecules/PlanSubscribingPeriod.vue'

@Component({
  components: { WillUnsubscribe, PlanSubscribingPeriod, BaseState },
})
export default class Subscribed extends Vue {
  @Prop({ required: true })
  readonly plan: SubscribedPaidMembershipPlan

  get pathToSubscribe(): string {
    return `/paid-membership/unsubscribe/${this.plan.externalId}/${this.plan.subscribeId}`
  }
}
